import { useNavigate } from 'react-router-dom'

interface TransactionErrorProps {
  message: string
  title?: string
}

function TransactionError({ message, title }: TransactionErrorProps) {
  const navigate = useNavigate()

  return (
    <div className="flex min-h-screen w-full items-center justify-center">
      <div className="text-center space-y-4">
        <h1 className="text-2xl font-semibold text-destructive">
          {title || 'Error Loading Transaction'}
        </h1>
        <p className="text-gray-600">
          {message || "Transaction not found or you don't have permission to view it."}
        </p>
        <button
          onClick={() => navigate(-1)}
          className="px-4 py-2 bg-main/90 text-white rounded hover:bg-main cursor-pointer"
        >
          Go Back
        </button>
      </div>
    </div>
  )
}

export { TransactionError }
